import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import roleMiddleware from "@/router/roleMiddleware";
import {ROLES} from "@/utils/constants";

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    component: () => import('../layouts/AuthorizationLayout'),
    children: [
      {
        path: '/login',
        name: 'login',
        meta: {
          public: true,
          onlyWhenLoggedOut: true
        },
        component: () => import('../views/auth/login')
      }
    ]
  },
  {
    path: '',
    component: () => import('../layouts/MainLayout'),
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('../views/cabinet/index'),
        meta: {
          roles: [ROLES.superAdmin, ROLES.mko]
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/cabinet/dashboard'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/mko',
        name: 'mko-index',
        component: () => import('../views/cabinet/mko/index'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/mko/create',
        name: 'mko-create',
        component: () => import('../views/cabinet/mko/item'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/mko/:id',
        name: 'mko-edit',
        props: true,
        component: () => import('../views/cabinet/mko/item'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/mko/updated/:id',
        name: 'mko-update',
        props: true,
        component: () => import('../views/cabinet/mko/update'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/price',
        name: 'price-index',
        component: () => import('../views/cabinet/prices/index'),
        meta: {
          roles: [ROLES.superAdmin]
        }
      },
      {
        path: '/katm-users',
        name: 'katm-users-index',
        component: () => import('../views/cabinet/kat-users/index'),
        meta: {
          roles: [ROLES.superAdmin]
        }
      },
      {
        path: '/credits',
        name: 'credit-index',
        component: () => import('../views/cabinet/credit/index'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/credits/create',
        name: 'credit-create',
        component: () => import('../views/cabinet/credit/create'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/credits/:id',
        props: true,
        name: 'credit-item',
        component: () => import('../views/cabinet/credit/item'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/tariffs',
        name: 'tariff-index',
        component: () => import('../views/cabinet/tariff/index'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/debtors',
        name: 'debtors-index',
        component: () => import('../views/cabinet/debtors/index'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/transactions',
        name: 'transactions-index',
        component: () => import('../views/cabinet/transaction/index'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/credit-calculator',
        name: 'credit-calculator',
        component: () => import('../views/cabinet/credit/calculator'),
        meta: {
          roles: [ROLES.mko]
        }
      },
      {
        path: '/report',
        name: 'report-index',
        component: () => import('../views/cabinet/report/index'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/black-list',
        name: 'black-list-index',
        component: () => import('../views/cabinet/black-list/index'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/workers',
        name: 'workers-index',
        component: () => import('../views/cabinet/workers/index'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
    ]
  },
  {
    path: '/empty',
    component: () => import('../layouts/Empty'),
    children: [
      {
        path: '/user/info/:creditId?',
        name: 'user-info',
        props: true,
        component: () => import('../views/cabinet/user/info'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/user/salary-info/:creditId?',
        name: 'user-salary-info',
        props: true,
        component: () => import('../views/cabinet/user/salary-info'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
      {
        path: '/user/salary-info-tax/:creditId?',
        name: 'user-salary-info-tax',
        props: true,
        component: () => import('../views/cabinet/user/salary-info-tax'),
        meta: {
          roles: [ROLES.mko, ROLES.superAdmin]
        }
      },
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!store.getters.me
  if (to.name !== 'login' && !isAuthenticated) {
    next({name: 'login'})
  } else {
    if (to.name === 'login' && isAuthenticated) {
      if (store.getters.role === ROLES.mko) {
        next({name: 'dashboard'})
      } else {
        next({name: 'index'})
      }
    } else {
      if (to.meta.roles) {
        roleMiddleware(to.meta.roles, from, next)
      } else {
        next()
      }
    }
  }
});

export default router
